var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrganization(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "carbon:account"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.5 7.875H10.6875V9H4.5V7.875ZM4.5 10.6875H11.8125V11.8125H4.5V10.6875Z",
    fill: "black",
    fillOpacity: 0.82
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M15 3H3C2.73478 3 2.48043 3.10536 2.29289 3.29289C2.10536 3.48043 2 3.73478 2 4V14C2 14.2652 2.10536 14.5196 2.29289 14.7071C2.48043 14.8946 2.73478 15 3 15H15C15.2652 15 15.5196 14.8946 15.7071 14.7071C15.8946 14.5196 16 14.2652 16 14V4C16 3.73478 15.8946 3.48043 15.7071 3.29289C15.5196 3.10536 15.2652 3 15 3Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 83",
    x: 2,
    y: 5,
    width: 14,
    height: 1,
    fill: "#F9FAFB"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 84",
    x: 4.5,
    y: 7.875,
    width: 6.17505,
    height: 1.12843,
    fill: "#F9FAFB"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 85",
    x: 4.5,
    y: 10.6841,
    width: 7.3125,
    height: 1.12843,
    fill: "#F9FAFB"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrganization);
export default __webpack_public_path__ + "static/media/Organization.52a95c55a04ac0ad6ad639c594740958.svg";
export { ForwardRef as ReactComponent };